import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import ProductItem from "./ProductItem";

const useStyles = makeStyles((theme) => ({
  productList: {
    padding: theme.spacing(2),
  },
  expandButton: {
    marginTop: theme.spacing(1),
    textTransform: "none",
    color: "#2196f3",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
}));

const MAX_VISIBLE_ITEMS = 3;

export default function ProductList({ products, isLoading = false }) {
  const classes = useStyles();
  const [isExpanded, setIsExpanded] = useState(false);

  if (isLoading) {
    return (
      <div className={classes.productList}>
        <CircularProgress size={24} />
      </div>
    );
  }

  if (!products || products.length === 0) {
    return (
      <div className={classes.productList}>
        <Typography variant="body2" color="textSecondary">
          No products found
        </Typography>
      </div>
    );
  }

  const shouldShowExpandButton = products.length > MAX_VISIBLE_ITEMS;
  const visibleProducts = isExpanded
    ? products
    : products.slice(0, MAX_VISIBLE_ITEMS);

  return (
    <div className={classes.productList}>
      {visibleProducts.map((product, index) => (
        <ProductItem key={index} product={product} />
      ))}
      {shouldShowExpandButton && (
        <Button
          className={classes.expandButton}
          onClick={() => setIsExpanded(!isExpanded)}
          size="small"
        >
          {isExpanded
            ? `Show less (${products.length - MAX_VISIBLE_ITEMS} hidden)`
            : `Show more (${products.length - MAX_VISIBLE_ITEMS} more)`}
        </Button>
      )}
    </div>
  );
}
